/// <reference lib="webworker" />

import { isNullish } from "@commonHelpers/math-utils";
import { interval } from "rxjs";

addEventListener('message', ({ data }) => {
	if (!isNullish(data.initTimer)) {
		interval(data.initTimer).subscribe(() => postMessage(''));
	}
});
